/* eslint-disable react/jsx-props-no-spreading */

import Link from './Link'

const LinkContainer = (props) => {
    return (
        <Link
            {...props}
        />
    )
}

export default LinkContainer
